module.exports = __webpack_public_path__ + "static/media/background_1920-11.b7f68e8a.jpg";